<template>
  <div class="p-1">
    <div-table
      :config="configList"
      :data="orders"
      :idWharhouse="idWharhouse"
      :currentUser="currentUser"
      :sous_idWharhouse="sous_idWharhouse"
      :sous_warehouses="sous_warehouses"
      :statusOrder="statusOrder"
      :statusOrderToChange="statusOrderToChange"
      :zones="zones"
      :products="products"
      :limit="limit"
      :element="element"
      @reset="reset"
      @refresh="refresh"
      @showProducts="showProducts"
      @filtrer="filtrer"
      @downloadOrders="downloadOrders"
      @Changelimit="Changelimit"
      @search="search"
      :loading="loading"
      :paginate="paginate"
      @paginatation="paginatation"
      @CheckQteDefecteuseOrder="CheckQteDefecteuseOrder"
      :CheckQteDefecteuseorderexist="CheckQteDefecteuseorderexist"
      @emtyTabId="emtyTabId" @selectAllCheckbox="selectAllCheckbox" @getRowDetail="getRowDetail" :tabId="tabId"
    ></div-table>
  </div>
</template>

<script>
import button from "../../components/~/button.vue";
import config from "./config";
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
     sous_idWharhouse: { type: String},
     sous_warehouses: { type: Array},
   },
  data() {
    return {
      configList: config.list,
      loading: false,
      statusGlobal:[],
      CheckQteDefecteuseorderexist:false,
      formData: {
        customer: {},
      },
      orders: [],
      element: {},
      sellers: [],
      tabId:[],
      show_modal: false,
      limit: 50,
      filters:{limit: 50,},
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      statusOrder: [],
      statusOrderToChange: [],
      zones: [],
      //currentUser: {},
      products:[],
     // idWharhouse:null
    };
  },
  computed: {
    warhouseSelected(){
          return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
      },
  }, 
  watch: { 
      'warhouseSelected': async function(oldVal, newVal) {
          //  await this.getwharhouseId();
          //  await this.reset();
          
          //  if(this.currentUser && this.currentUser.type && this.currentUser.type != "Seller") {
          //    await this.getSellers();
          //    await this.getZones();
          //    this.setDataSelect("seller", this.sellers, null);
          // }else{this.limit=10;this.filters.limit=10}
      },
      'idWharhouse': async function(oldVal, newVal) {
          this.idWharhouse=oldVal;  
          console.log('idWharhouse watch --------',this.idWharhouse.country)
          console.log('sous_idWharhouse watch orders --------',this.sous_idWharhouse)
          console.log('sous_warehouses watch orders --------',this.sous_warehouses)
          if(this.currentUser.type != "Seller") {
            await this.getSellers();
            await this.getZones();
            this.setDataSelect("seller", this.sellers, null);
          }

          if(this.currentUser.type != "Admin") {this.limit=10;this.filters.limit=10}
          
          await this.reset({isChangeW:true});
      },
      'sous_idWharhouse': async function(oldVal, newVal) {
          this.sous_idWharhouse=oldVal;  
          if(this.currentUser.type != "Admin") this.limit=10;this.filters.limit=10
          await this.reset({isChangeW:true});
      }
},
  async mounted() {
    //await this.getUser();
    console.log('idWharhouse --------',this.idWharhouse.country)
    console.log('sous_idWharhouse orders --------',this.sous_idWharhouse)
    console.log('sous_warehouses orders --------',this.sous_warehouses)
    if(this.currentUser.type != "Admin"){this.limit=10;this.filters.limit=10}
    await this.getStatus();
    if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
    else {
      let filtersobjectToQueryString={limit:this.limit,warehouse:this.idWharhouse._id};
      if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filtersobjectToQueryString['details.warehouseParent']=this.sous_idWharhouse;
      this.$f.objectToQueryString(filtersobjectToQueryString);
    }

    if(this.filters.name) await this.search(this.filters.name);
    else await this.getOrders(this.filters);

    if(this.currentUser && this.currentUser.type && this.currentUser.type != "Seller"){
      await this.getZones();
      await this.getSellers();
    }else await this.getProducts();

    this.setDataSelect("seller", this.sellers, null);
    this.setDataSelect("status", this.statusOrder, null);
    this.setDataSelect("status_pending", [{name:"pending"},{name:"pending_unrached"},{name:"pending_remind"}], null);
     if (this.currentUser.type && this.currentUser.type == "Seller") {
        let pos = this.configList.columns.map(function (e) {return e.name;}).indexOf('Seller');
        if(pos!=-1) this.configList.columns.splice(pos, 1);  
        let posW = this.configList.columnsDialog.elements.map(function (e) {return e.name;}).indexOf('warehouse');
        if(posW!=-1)  this.configList.columnsDialog.elements.splice(posW, 1);  
    }
  },
  methods: {
    async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    }, 
    selectAllCheckbox($event) {
        let columns = document.querySelectorAll('.rowCheckbox');
        this.tabId = [];
        if ($event.target.checked == true) {
            columns.forEach(column => {
                column.checked = true;             
                this.tabId.push(column.id);
            });
        } else {
            columns.forEach(column => {column.checked = false});
            this.tabId = [];
        }
    },
    getRowDetail(item, id) {
        // let rows = this.selectedRows;
        let itemInRow = this.tabId.filter(item => item === id);
        let isItemInRow = itemInRow.length > 0;
            
        if (isItemInRow) { 
            let pos = this.tabId.map(function (e) {return e;}).indexOf(id);
            this.tabId.splice(pos, 1);
        } else {
            this.tabId.push(id);
        }
          if(this.tabId.length === 0){
              let columns = document.querySelectorAll('.checkallbbox');
              columns.forEach(column => {column.checked = false});
        }
    },
    emtyTabId(){
      let columns = document.querySelectorAll('.rowCheckbox');
      columns.forEach(column => {column.checked = false});
      this.tabId = [];
    },
    async Changelimit(val){
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
       this.filters['limit']=val;
       this.filters['page']=1;
       this.paginate.currentpage=1;
       this.$f.objectToQueryString(this.filters)
       if(this.filters.name) await this.search(this.filters.name);
       else this.getOrders(this.filters);
    },
     sumQteProduct(data){
      let sum=0;
      for (let i in data) {
        sum=sum+data[i].quantity;
      }
      return sum;
    },
     sumProduct(data){
      let product="";
      for (let i in data) {
        product+=data[i].product.name
        if(data.length-1 != i) product+=" ,"; 
      }
      return product;
    },
    async downloadOrders(){
        var arr = typeof this.orders !== 'object' ? JSON.parse(this.orders) : this.orders;
        for (let i in arr) {
              arr[i].IdOrder=this.$f.getIdbySplit(arr[i].id.replace('#',''));
              arr[i].Seller=arr[i].seller.email;
              arr[i].Customer=arr[i].customer.fullName.replace(/[^a-zA-Z 0-9]+/g,'');
              arr[i].Phone=arr[i].customer.phone;
              arr[i].Products =this.sumProduct(arr[i].details);
              arr[i].ShippingAddress=arr[i].customer.shippingAddress?arr[i].customer.shippingAddress.replace(/[^a-zA-Z 0-9]+/g,''):'';
              arr[i].TotalPrice=arr[i].totalPrice;
              arr[i].OrderDate =this.$moment(arr[i].date).format("yyyy-MM-DD HH:mm");
              arr[i].Status=arr[i].status.name;
              arr[i].ReasonOrder=arr[i].comment?arr[i].comment:"";
        }
        for (let j in arr) {
              delete arr[j].statusCallcenter;
              delete arr[j].teleConsultantConfirm;
              delete arr[j].lastUnreachedDate;
              delete arr[j].updatedAt;
              delete arr[j].sameOrderUnreached;
              delete arr[j].random;
              delete arr[j].unreachedBy;
              delete arr[j].totalPrice;
              delete arr[j]._id;
              delete arr[j].totalFees;
              delete arr[j].teleConsultant;
              delete arr[j].status;
              delete arr[j].source;
              delete arr[j].seller;
              delete arr[j].processedPrice;
              delete arr[j].processedAt;
              delete arr[j].paidAt;
              delete arr[j].isRefunded;
              delete arr[j].isDeleted;
              delete arr[j].details;
              delete arr[j].date;
              delete arr[j].customer;
              delete arr[j].createdAt;
              delete arr[j].comment;
              delete arr[j].skippedBy;
              delete arr[j].id;
               delete arr[j].__v;
                delete arr[j].vat;
          }
          console.log('orders rr______',arr)
        let str =
          `${Object.keys(arr[0])
            .map((value) => `"${value}"`)
            .join(',')}` + '\r\n';
        let csvContent = arr.reduce((st, next) => {
          st +=
            `${Object.values(next)
              .map((value) => `"${value}"`)
              .join(',')}` + '\r\n';
          return st;
        }, str);
        let element = document.createElement('a');
        element.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent);
        element.target = '_blank';
        element.download = 'orders.csv';
        element.click();
      //  await this.getOrders({ limit: this.limit });
      //   console.log('orders new______',this.orders)
    },
     setDataSelect(model, data, splice , noSelect=null) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if ((this.configList.filters.elements.champs[i].type === "select" && this.configList.filters.elements.champs[i].key === model) || noSelect) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            if(!noSelect) this.configList.filters.elements.champs.splice(i, 1);
            else this.configList.filters.elements.champs[i].value=null;
          }
        }
      }
    },
    async getStatusByName(name,statusOrder=null) {
        let filters={name: name};
        if(statusOrder) filters.statusOrder=true;
        const result = await this.$server.get("status",filters);
        return result.content;
    },
    async CheckQteDefecteuseOrder(item){
       this.CheckQteDefecteuseorderexist=false;

       if(item.status.name == "Refunded" ){
             for (let i in item.details) {
                 const filters = {
                   product: item.details[i].product._id,
                   order: item._id,
                   shipping:null
                 };
               const res = await this.$server.search("stockHistories", filters);
              
               if(typeof res.content.results !== 'undefined') {
                   item.details[i].product.qteChange=res.content.results[0].quantity;
                   this.CheckQteDefecteuseorderexist=true;
               }  
             }
       }    
          //console.log('stst hist',item)
       // console.log('CheckQteDefecteuseorderexist',this.CheckQteDefecteuseorderexist)
     }, 
    async getSellers() {
      const filter = {
         type: "Seller",
         warehouses:this.idWharhouse._id,
         limit:10,
      };
       if (this.currentUser.type != "Seller") {
        const res = await this.$server.search("users", filter);
        if (res.content.results) this.sellers = res.content.results;
        else this.sellers = [];
       }
       //console.log('selller___________________', this.sellers)
    },
    async reset(data) {
      let lmitt=this.limit;
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
      if(this.filters['limit']) lmitt=this.filters['limit'];
      this.filters['page']=1;
      let filtersobjectToQueryString={limit:lmitt,warehouse:this.idWharhouse._id};
      if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filtersobjectToQueryString['details.warehouseParent']=this.sous_idWharhouse;
      this.$f.objectToQueryString(filtersobjectToQueryString);
      if(data.isChangeW) filtersobjectToQueryString.isChangeW=true;
      await this.getOrders(filtersobjectToQueryString);

      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
          if (this.configList.filters.elements.champs[i].type === "range_numbers"){
             this.configList.filters.elements.champs[i].value = {min:0,max:0};
          } 
      }
    },
    async filtrer(data) {
       if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
       delete  this.filters.page;
       delete  this.filters.name;

       console.log('filter search________',data)
       this.paginate.currentpage=1;
       this.filters['warehouse']=this.idWharhouse._id;
       if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') this.filters['details.warehouseParent']=this.sous_idWharhouse;else delete this.filters['details.warehouseParent'];
       if(!this.filters['limit']) this.filters['limit']=this.limit;
       if(data.Range_updatedAt){this.filters.Range_updatedAt=data.Range_updatedAt.map( el => this.$moment(el).format('yyyy-MM-DD'));delete this.filters.Range_date;}else delete this.filters.Range_updatedAt;
       if(data.Range_date){this.filters.Range_date=data.Range_date.map( el => this.$moment(el).format('yyyy-MM-DD'));delete this.filters.Range_updatedAt;this.setDataSelect("Range_updatedAt", [], 1,'empty');}else delete this.filters.Range_date;
      //  if(data.from && data.to){delete this.filters.date;this.filters.from=data.from;this.filters.to=data.to;}else {delete this.filters.from; delete this.filters.to;}
       if(data.seller)  {this.filters.seller=data.seller._id; await this.getProducts(data.seller._id);}else delete this.filters.seller;
       if(data.phone) this.filters.phone=data.phone;else delete this.filters.phone;
       if(data.product)  this.filters['details.product']=data.product._id;else delete this.filters['details.product'];
       if(data.status)  this.filters.status=data.status._id;else delete this.filters.status;
       if(data.status_pending) this.filters.status_pending=data.status_pending.name;else delete this.filters.status_pending;
       if(data.range_numbers && data.range_numbers.max){this.filters.unreachedBySize=[data.range_numbers.min,data.range_numbers.max]}else delete this.filters.unreachedBySize;
       this.$f.objectToQueryString(this.filters)
       await this.getOrders(this.filters);
    },
    /**********************************User and Status******************************************************/
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
      console.log(res.content);
    },

   

    statusToUpdate(data=null){
         
            if(this.currentUser.type === 'Seller' && this.currentUser.statusToUpdate.length>0){
                this.statusOrderToChange=[];
                let conVertInarray=this.currentUser.statusToUpdate.map(el => el.split('->')).reduce((r, e) => (r.push(...e), r), []);
                conVertInarray= conVertInarray.filter(function(item, pos) {
                  return conVertInarray.indexOf(item) == pos;
                })

                conVertInarray.forEach(arg => {
                    this.statusOrderToChange.push(this.statusGlobal.find(e => e.name.toLowerCase() === arg.toLowerCase()).id)
                });
            }
         
    },
   
    async getStatus() {
      this.statusGlobal=[];
       let idCo = await this.getStatusByName("Confirmed");
       let idC = await this.getStatusByName("Cancelled");
       let idU = await this.getStatusByName("Unreached");
       let idUU = await this.getStatusByName("Expired");
       let Pe = await this.getStatusByName("Pending");
       let Ou = await this.getStatusByName("Waiting");
       let Spam = await this.getStatusByName("Spam");
       let Double = await this.getStatusByName("Double");
       let depot = await this.getStatusByName("En attente de dépot");
       let wronNumber = await this.getStatusByName("wrong number");
       this.statusGlobal.push({name:'Confirmed',id:idCo},{name:'Cancelled',id:idC},{name:'Unreached',id:idU},{name:'Expired',id:idUU},{name:'Pending',id:Pe},{name:'Waiting',id:Ou},{name:'Spam',id:Spam},{name:'Double',id:Double},{name:'En attente de dépot',id:depot},{name:'wrong number',id:wronNumber})

      if (this.currentUser.type !== "CallenterManager"){
        this.statusOrder=[Pe,Ou,depot,wronNumber,idCo,idC,idU,idUU,Spam,Double];
        this.statusOrderToChange=[Pe,Ou,depot,wronNumber,idCo,idC,idU,idUU,Spam,Double];
        this.statusToUpdate();
       
      }else {
        this.statusOrder=[idCo,idC,idU,depot];
        this.statusOrderToChange=[idCo,idC,idU,depot];
      }
    },
    async getZones() {
      if (this.currentUser.type != "Seller") {
        const res = await this.$server.search("zones",{ limit: 5,warehouse:this.idWharhouse._id});
        if (res.content.results) this.zones = res.content.results;
        else this.zones = [];
      } else {
        this.zones = [];
      }
    },
    getStatusId(status) {
      for (let i in this.statusOrder) {
        if (this.statusOrder[i].name == status) {
          return this.statusOrder[i]._id;
        }
      }
    },

    async assign(index) {
      if (!this.orders[index].teleConsultant) {
        this.orders[index].teleConsultant = this.currentUser._id;
        const res = await this.$server.update("orders", this.orders[index]);
        //console.log(res);
      }
    },
    /*******************************************Modal (View) update Chapping address and Status Order ************************************/

    /*********************************************************************************************************************************** */
    getAccess(modelToCheck, accessToCheck) {
      const permissions = this.currentUser.role.permissions;
      for (let i in permissions) {
        let model = permissions[i]["model"];
        let access = permissions[i]["access"];
        if (model == modelToCheck) {
          return access[accessToCheck];
        }
      }
    },
    async refresh() {
        if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
        this.$f.objectToQueryString(this.filters)
        if(this.filters.name) await this.search(this.filters.name);
        else await this.getOrders(this.filters);
      //  if(this.filters['page'] && this.filters['page']>1 && this.orders.length==0){
      //     this.filters['page']= --this.filters['page'];
      //      this.$f.objectToQueryString(this.filters)
      //     await this.getOrders(this.filters);
      //  }
    },
    async getProducts(seller=null){
      const filter={'details.warehouse':this.idWharhouse._id,limit:10};
      if(seller) filter.seller=seller;
      const res = await this.$server.search("products",filter);
      //console.log('res pproduct----------',res.content)
      if (res.content.results) {
        this.products = res.content.results;
      } else this.products = [];
    },
    showProducts(index) {
      if (this.element !== this.orders[index]) {
        this.element = this.orders[index];
        //console.log("Je suis this.element", this.element);
      } else this.element = null;
    },
    async getOrders(filters) {
      this.loading = true;
     if(filters.isChangeW){ delete filters.isChangeW;this.orders = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}} 
      filters['warehouse']=this.idWharhouse._id;
      if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters['details.warehouseParent']=this.sous_idWharhouse;
      console.log('filter autorize__________',filters)
      const res = await this.$server.search("orders", filters);
      this.loading = false;
      if (res && res.content && res.content.results && this.currentUser.type != "CallenterManager") {
        this.orders = res.content.results;
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.orders = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
      }
    },
    async search(data,dataFilter=null) {
      console.log('dataFilter----',dataFilter)
       this.paginate= {total: 0,currentpage: 1,lastpage: 1,per_page: 0,};
       let limitt=this.limit
       if(this.filters['limit']) limitt=this.filters['limit'];
       let search = {
          name:data.trim(),
          limit:parseInt(limitt)
       }
       if(dataFilter && dataFilter.key){
          search[dataFilter.key]=data.trim()
          delete search.name;
       } 
       console.log('search----',search)
      if (this.currentUser.type == "Seller") search.seller = this.currentUser._id;
      if (this.currentUser.type == "CallenterManager") search.CallenterManager = this.currentUser._id;
     search["warehouse"]=this.idWharhouse._id;
     if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') search['details.warehouseParent']=this.sous_idWharhouse;
     this.$f.objectToQueryString(search)
     this.loading = true;
     const  res = await this.$server.find("orders", search);
     this.loading = false;
       if (res && res.content.results) {
        this.orders = res.content.results; 
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.orders = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
      }
        
    },
    async remove(id) {
      this.$confirm("You want to delete this order?").then(async (res) => {
        if (res) {
          const resp = await this.$server.delete("orders", { id: id });
          await this.refresh();
          alert("order Deleted", "success");
        }
      });
    },
    /********************************************************************************************/
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
      this.filters['page']=page;
      this.$f.objectToQueryString(this.filters)

      this.getOrders(this.filters);
    },

    /*******************************************Fin Modal (View) update Chapping address and Status Order **********************************/
    /* ToDetail(id) {
      //:to="{ path: `/orders/detail/${item._id}` }"
      history.pushState(this.paginate, " ", `/orders/detail/${id}`);
      this.$router.push(`/orders/detail/${id}`);
    },*/
  },
};
</script>

<style>
/* animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}
dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}
@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/**********************************Table Product PopUp ***************************/


th:not(:last-child) {
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
}
</style>
